import React, { Fragment } from 'react';

import UserDetail from '../../components/user/Detail';

const Detail = ({ match }) => (
    <Fragment>
        <div className="content-header">
            <h1>User</h1>
        </div>
        <div className="card">
            <div className="card-header">
                <h4>User Detail</h4>
            </div>
            <div className="card-body">
                <UserDetail id={match.params.id}/>
            </div>
        </div>
    </Fragment>
)

export default Detail;